import React from 'react'
import MainLayout from '../layouts/main-layout'
import Header from '../layouts/header/header'

const ErrorOccurred = () => {
   return (
      <MainLayout>
         <Header />
         <main className="container">
            <div>
               <p>Sorry, an error occured. Please refresh the page to try again</p>
            </div>
         </main>
      </MainLayout>
   )
}

export default ErrorOccurred
